import { useSync } from "~/providers/sync-provider";

export function SyncIndicator() {
	const { online, syncing, pendingCount } = useSync();

	const label = online ? "Online" : "Offline";
	const dotClass = online ? "bg-green-500" : "bg-amber-500";

	return (
		<div className="flex items-center gap-2 rounded-full bg-slate-800/80 px-3 py-1 text-xs text-slate-200">
			<span className={`h-2 w-2 rounded-full ${dotClass} ${syncing ? "animate-pulse" : ""}`} />
			<span>{label}</span>
			{pendingCount > 0 && (
				<span className="rounded-full bg-amber-500/20 px-2 py-0.5 text-amber-300">
					{pendingCount} pending
				</span>
			)}
		</div>
	);
}
